var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { HttpBooksApiV5Request } from "./http-api-request.js";
import { HttpRequest } from "./http-request.js";
export function getBalances(bookId, query, config) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        let response = yield new HttpBooksApiV5Request(`${bookId}/balances`, config).addParam('query', query).addParam('time', Date.now()).fetch();
        const balancesUrl = (_a = response.data) === null || _a === void 0 ? void 0 : _a.balancesUrl; // Expected for large payloads
        if (balancesUrl) {
            const balancesResponse = yield new HttpRequest(balancesUrl).setMethod('GET').execute();
            response = { data: balancesResponse.data, status: balancesResponse.status };
        }
        return response.data;
    });
}
//# sourceMappingURL=balances-service.js.map